import { render, staticRenderFns } from "./SubMenuFaturamento.vue?vue&type=template&id=c0865ec0&"
import script from "./SubMenuFaturamento.vue?vue&type=script&lang=js&"
export * from "./SubMenuFaturamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports